import './Main.css';
import school from '../../images/school.webp';
import { Link } from 'react-router-dom';

function Main() {
    return (
        <>
            <div className="info">
                <div className="text-content">
                    <h1>Добро пожаловать на виртуальную экскурсию по нашей школе</h1>
                    <p>Исследуйте наше образовательное учреждение в интерактивном формате</p><br />
                    <Link to="/Choose_floor" className="btn-btn">Начать экскурсию ➜</Link>
                </div>
                <div className="image-placeholder">
                    <img src={school} alt="Фото школы" />
                </div>
            </div>
        </>
    );
}

export default Main;